<template>
  <center class="m-10">
    <img
      width="150"
      height="150"
      src="/media/svg/soha/access.svg"
    >
    <br>
    <h3>{{ message }}</h3>
  </center>
</template>

<script>
export default {
  name: "NoAccess",
  props: {
    message: {
      type: String,
    },
  },
};
</script>
